function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';

class WidgetFooter extends Component {
  render() {
    return React.createElement("footer", {
      className: "admin-widget__footer"
    }, this.props.children);
  }

}

_defineProperty(WidgetFooter, "defaultProps", {});

export default WidgetFooter;